import { useScrollToTop } from "core/hooks/useScrollToTop";
import AppLayout from "core/layouts/AppLayout";
import BottomNavigation from "core/layouts/BottomNavigation";
import { RouterName } from "core/router";
import { useGetCountCart } from "modules/Carts/hooks";
import { useRecipe } from "modules/Ingredients/hooks/recipe";
import { useResetRecipe, useSearchRecipes } from "modules/Recipes/hooks/recipe";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import CommunityLineSection from "../components/Community/CommunityLineSection";
import CommunityTabSection from "../components/Community/CommunityTabSection";
import EnrichmentSection from "../components/EnrichmentSection";
import FavoritesSection from "../components/FavoritesSection";
import FoodSuggestions from "../components/FoodSuggestions";
import HistoriesSection from "../components/HistoriesSection";
import IngredientsSection from "../components/IngredientsSection";
import PhotoRegistration from "../components/PhotoRegistration";
import UserSuggestions from "../components/UserSuggestions";
import VideoSection from "../components/VideoSection";

const MainPage = () => {
  useScrollToTop();
  const navigate = useNavigate();
  const { resetRecipes } = useRecipe();
  const clientSetting = useSelector((state: any) => state.AppSettings);
  const isCommunityTab = clientSetting?.data?.configs?.community_tab || false;
  useGetCountCart();
  
  const onResetRecipe = useResetRecipe();
  const { resetSearch } = useSearchRecipes();
  const [refresh, setRefresh] = useState("");
  const [searchParams] = useSearchParams();
  useEffect(() => {
    if (searchParams.get("refresh") === "true")
      setRefresh(new Date().getTime().toString());
    navigate(RouterName.MAIN);
  }, [searchParams.get("refresh")]);

  useEffect(() => {
    resetRecipes();
    resetSearch();
    onResetRecipe();
    if (["android"].includes((window as any)._APP_PLATFORM.toLowerCase())) {
      (window as any).webViewRequestAdmob("ADMOB_EXIT");
    }
  }, []);

  return (
    <AppLayout className={` bg-gray-100 pb-[70px]`}>
      <PhotoRegistration />
      <IngredientsSection />
      <HistoriesSection refresh={refresh} />
      <UserSuggestions refresh={refresh} />
      <EnrichmentSection refresh={refresh} />
      <FoodSuggestions refresh={refresh} />
      <FavoritesSection refresh={refresh} />
      <VideoSection refresh={refresh} />
      {
        isCommunityTab ? <CommunityTabSection /> : <CommunityLineSection />
      }
      <BottomNavigation onNavigateChange={resetRecipes} activeIndex={1} />
    </AppLayout>
  );
};

export default MainPage;
